import React from 'react'
import ReactQuill from 'react-quill';
import './writeQuill.css';
import { Context } from '../../../App';
import { useState, useEffect, useContext, useRef, useReducer } from "react";

const modules = {
  toolbar: false,
};



function QuillEditor({ handleKeyDown, EnteredMessageData, allowEnter }) {
  const [text, setText] = EnteredMessageData;
  const containerRef = useRef(null);
  const [editorHeight, setEditorHeight] = useState(53);
  const isDragging = useRef(false);

  const startDragging = () => (isDragging.current = true);
  const stopDragging = () => (isDragging.current = false);

  const handleMouseMove = (e) => {
    if (!isDragging.current || !containerRef.current) return;
    const containerTop = containerRef.current.getBoundingClientRect().top;
    const newHeight = e.clientY - containerTop;
    if (newHeight > 50 && newHeight < 500) {
      setEditorHeight(newHeight);
    }
  };

  useEffect(() => {
    const handleTouchMove = (e) => {
      if (!isDragging.current || !containerRef.current) return;

      // Prevent browser pull-to-refresh
      e.preventDefault();

      const containerTop = containerRef.current.getBoundingClientRect().top;
      const newHeight = e.touches[0].clientY - containerTop;
      if (newHeight > 50 && newHeight < 500) {
        setEditorHeight(newHeight);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', stopDragging);

    // ❗ Make sure passive is false so we can preventDefault
    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('touchend', stopDragging);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', stopDragging);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', stopDragging);
    };
  }, []);


  return (
    <div
      ref={containerRef}
      className="relative mx-3 md:mx-4 overflow-hidden rounded-lg bg-white border border-gray-300 w-full"
      onKeyDownCapture={(e) => {
        if (!allowEnter && e.code === 'Enter' && !e.shiftKey) {
          e.preventDefault();
        }
      }}
    >
      <ReactQuill
        value={text}
        onChange={setText}
        placeholder={"Your Message..."}
        modules={modules}
        theme="snow"
        onKeyDown={handleKeyDown}
        style={{ height: `${editorHeight}px`, width: '100%' }}
      />

      {/* Drag handle */}
      <div
        onMouseDown={startDragging}
        onTouchStart={startDragging}
        className="h-1.5 md:h-0.5 w-full hover:bg-gray-100 cursor-row-resize absolute bottom-0 left-0"
      />
    </div>
  );
}

export default QuillEditor;